module.exports = __webpack_public_path__ + "assets/images/02_639ea152405b9e8404f9a167058191b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophies/02.png
// module id = 179
// module chunks = 0